const inputChangeToStateUpdate = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

    return { [event.target.name]: value };
};

const api = { inputChangeToStateUpdate };

export default api;
